/*
 * mv-wishlist.js — Jewellery by JF localStorage wishlist (Wave 1 shared foundation)
 * ------------------------------------------------------------------------
 * Self-initializing. localStorage key `mv:wishlist` = JSON array of
 *   { handle, title, image, url, price }.
 * Toggle buttons: [data-mv-wish][data-mv-wish-handle]
 *   optional: data-mv-wish-title, data-mv-wish-image, data-mv-wish-url, data-mv-wish-price
 * Reflects state: .is-wished class + aria-pressed + heart glyph (filled/outline).
 * Updates every [data-mv-wish-count]. Exposes window.MVWishlist.
 * Dispatches `mv:wishlist:changed`. Initializes all buttons on load.
 */
(function () {
  'use strict';
  if (window.MVWishlist) return; // idempotent

  var KEY = 'mv:wishlist';
  var HEART_FILLED = '♥'; // ♥
  var HEART_OUTLINE = '♡'; // ♡

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) {
      /* storage full or unavailable — fail silently */
    }
  }

  function indexOf(arr, handle) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] && arr[i].handle === handle) return i;
    }
    return -1;
  }

  function has(handle) {
    return indexOf(read(), handle) > -1;
  }

  function all() {
    return read();
  }

  function updateCounts(len) {
    Array.prototype.slice.call(document.querySelectorAll('[data-mv-wish-count]')).forEach(function (el) {
      if (len > 0) {
        el.textContent = String(len);
        el.removeAttribute('hidden');
      } else {
        el.textContent = '';
        el.setAttribute('hidden', '');
      }
    });
  }

  function reflectButton(btn, wished) {
    if (!btn) return;
    btn.classList.toggle('is-wished', wished);
    btn.setAttribute('aria-pressed', wished ? 'true' : 'false');
    var glyph = btn.querySelector('[data-mv-wish-glyph]');
    var target = glyph || btn;
    // Only overwrite text if the button (or its glyph slot) is glyph-driven.
    if (glyph || btn.hasAttribute('data-mv-wish-glyph-self')) {
      target.textContent = wished ? HEART_FILLED : HEART_OUTLINE;
    }
  }

  function refreshAllButtons() {
    var arr = read();
    Array.prototype.slice.call(document.querySelectorAll('[data-mv-wish][data-mv-wish-handle]')).forEach(function (btn) {
      var handle = btn.getAttribute('data-mv-wish-handle');
      reflectButton(btn, indexOf(arr, handle) > -1);
    });
    updateCounts(arr.length);
  }

  function objFromButton(btn) {
    return {
      handle: btn.getAttribute('data-mv-wish-handle'),
      title: btn.getAttribute('data-mv-wish-title') || '',
      image: btn.getAttribute('data-mv-wish-image') || '',
      url: btn.getAttribute('data-mv-wish-url') || '',
      price: btn.getAttribute('data-mv-wish-price') || ''
    };
  }

  function toggle(obj) {
    if (!obj || !obj.handle) return false;
    var arr = read();
    var i = indexOf(arr, obj.handle);
    var wished;
    if (i > -1) {
      arr.splice(i, 1);
      wished = false;
    } else {
      arr.push({
        handle: obj.handle,
        title: obj.title || '',
        image: obj.image || '',
        url: obj.url || '',
        price: obj.price || ''
      });
      wished = true;
    }
    write(arr);
    refreshAllButtons();
    document.dispatchEvent(new CustomEvent('mv:wishlist:changed', {
      detail: { handle: obj.handle, wished: wished, all: arr }
    }));
    return wished;
  }

  var listeners = [];
  function on(cb) {
    if (typeof cb === 'function') {
      listeners.push(cb);
      document.addEventListener('mv:wishlist:changed', function (e) { cb(e.detail); });
    }
  }

  // Delegated toggle handling.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mv-wish][data-mv-wish-handle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(objFromButton(btn));
  }, false);

  window.MVWishlist = {
    has: has,
    toggle: toggle,
    all: all,
    on: on,
    refresh: refreshAllButtons
  };

  function init() { refreshAllButtons(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Keep buttons in sync across the same tab after any change.
  document.addEventListener('mv:wishlist:changed', refreshAllButtons);
  // Sync across tabs.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) refreshAllButtons();
  });
})();
